import { FunctionComponent, useContext, useEffect } from "react";

//OpenLayers
import { KeyboardPan } from "ol/interaction";

//Custom components
import MapContext from "@/components/Map/MapContext";
import { registerOlInteraction } from "@/lib/olHelpers";

//Types
import { MapContextType } from "@/@types/context/MapContext";

const KeyboardPanInteraction: FunctionComponent<any> = (props) => {
  const context = useContext(MapContext) as MapContextType;

  const options = {
    condition: undefined,
    duration: undefined,
    pixelDelta: undefined
  };

  const events = {
    change: undefined,
    "change:active": undefined,
    error: undefined,
    propertychange: undefined
  };

  useEffect(
    () =>
      registerOlInteraction(context, KeyboardPan, props, options, events),
    []
  );

  return null;
};

export default KeyboardPanInteraction;

